import React, { CSSProperties, FC } from 'react'
import { useDragLayer, DragLayerMonitor, XYCoord } from 'react-dnd'
import { DndBreadItem } from 'components/Dnd'
import styles from 'styles/components/form.module.scss'
import { getBreadShortName } from 'lib/helper'

const layerStyles: CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
}

const getItemStyles = (initialOffset: XYCoord | null, currentOffset: XYCoord | null) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    }
  }
  const { x, y } = currentOffset
  const transform = `translate(${x}px, ${y}px) scale(1.05)`
  return {
    transform,
    WebkitTransform: transform,
  }
}

const CustomDragLayer: FC = () => {
  const { itemType, isDragging, item, initialOffset, currentOffset } = useDragLayer((monitor: DragLayerMonitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }))

  function renderItem() {
    switch (itemType) {
      case 'item':
        return (
          <div className={styles.image__list__item}>
            <DndBreadItem name={getBreadShortName(item.bread)} imageUrl={item.bread.image_urls[0] || ''} />
          </div>
        )
      default:
        return null
    }
  }

  if (!isDragging) return null

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>{renderItem()}</div>
    </div>
  )
}

export default CustomDragLayer
